// Titel & Beschreibungen der festen Seiten – genutzt von den Seiten (SeoHead)
// UND von scripts/prerender-meta.js (statisches HTML pro URL für Google).
// Reine Daten: keine Imports/JSX, damit Node sie im Build direkt laden kann.
export const pageMeta = {
  "/": {
    title: "EDI Konverter – EDIFACT zu Excel, CSV, XML, JSON online",
    description: "🚀 EDIFACT-Dateien in 60 Sekunden konvertieren – direkt im Browser in Excel, CSV oder XML. Kostenlos, ohne Installation. Jetzt ausprobieren!",
    ogImage: "https://edi-converter.de/social.jpg",
  },
  "/edi-konverter": {
    title: "EDI Tool – EDIFACT in Excel, CSV, XML, JSON umwandeln",
    description: "🚀 EDIFACT-Dateien direkt im Browser in Excel, CSV, XML oder JSON konvertieren – kostenlos, ohne Installation & in 60 Sekunden. Jetzt Datei auswählen!",
    ogImage: "https://edi-converter.de/tool-social.jpg",
  },
  "/edifact-viewer": {
    title: "EDIFACT Viewer – EDI-Dateien direkt im Browser ansehen & bearbeiten",
    description: "📂 Öffne und bearbeite EDIFACT-Dateien direkt im Browser. Kein Upload, keine Installation, 100 % lokal & kostenlos.",
    ogImage: "https://edi-converter.de/viewer-social.jpg",
  },
  "/edifact-formatter": {
    title: "EDIFACT Formatter – EDI-Dateien professionell formatieren & strukturieren",
    description: "✂️ Formatiere EDIFACT-Dateien für bessere Lesbarkeit. Professioneller EDI-Formatter für saubere Struktur und einheitliche Darstellung.",
    ogImage: "https://edi-converter.de/tool-social.jpg",
  },
  "/edifact-validator": {
    title: "EDIFACT Validator – Fehler & Struktur prüfen | EDI-Converter",
    description: "🛡 Prüfe deine EDIFACT-Datei auf Syntax, Struktur & typische Fehler – direkt im Browser, 100% lokal & kostenlos.",
    ogImage: "https://edi-converter.de/tool-social.jpg",
  },
  "/glossar": {
    title: "EDIFACT Glossar – Alle Begriffe & Segmente erklärt | EDI-Converter",
    description: "📚 Komplettes EDIFACT-Glossar: UNB, UNH, INVOIC, ORDERS & mehr. Alle Segmente, Nachrichtentypen und Begriffe verständlich erklärt mit Beispielen.",
    ogImage: "https://edi-converter.de/social.jpg",
  },
  "/blog": {
    title: "EDIFACT Blog – Anleitungen & Praxistipps | EDI-Converter",
    description: "Anleitungen, Erklärungen und Praxistipps rund um EDIFACT: Konvertierung nach Excel, CSV, XML & JSON, Segmente, Nachrichtentypen und typische Fehler.",
    ogImage: "https://edi-converter.de/social.jpg",
  },
};

// Glossar-Detailseiten (gleiches Muster wie bisher in GlossarDetail.js)
export const glossarTermMeta = (term) => ({
  title: `${term.term} – ${term.fullName} erklärt | EDIFACT Glossar`,
  description: `${term.description.substring(0, 150)}... ✅ Beispiele, Struktur & Verwendung im EDIFACT-Standard.`,
  ogImage: "https://edi-converter.de/social.jpg",
});
